import styled from 'styled-components';

export const ScrollArrow = styled.div`
  position: absolute;
  left: ${(props) => (props.left ? '10px' : '')};
  right: ${(props) => (props.right ? '0px' : '')};
  cursor: pointer;
  z-index: 9;
  padding: 4px;
  border-radius: 3px;
  transition: background 0.2s ease-in-out;
  display: ${(props) => (props.visible ? 'block' : 'none')};
`;

export const VermArrow = styled.img`
  width: ${(props) => (props.width ? props.width : '14px')};
  height: ${(props) => (props.height ? props.height : '14px')};
  transform: ${(props) => props.rotate};
`;

export const CardScrollDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    display: none;
  }
`;
export const ScrollContainer = styled.div`
  display: flex;
  align-items: normal;
  transform: translateX(${(props) => props.xValue + 'px'});
  transition: transform 0.3s ease;
`;

export const BookNowCtabtn = styled.button`
  font-family: 'Montserrat';
  font-size: clamp(16px, 2vw, 14px);
  font-weight: 500;
  outline: none;
  background-color: #ef4e5e;
  color: #fff;
  border-radius: 6px;
  text-align: center;
  width: 100%;
  height: 44px;
  line-height: 44px;
  margin: ${(props) => (props.generalForm ? '18px 0 8px' : '20px 0')};
  border: 1px solid #ef4e5e;
  cursor: pointer;
  z-index: 999;
  background: ${(props) => (props.formSubmitted ? '#d9d9d9' : null)};
  cursor: ${(props) => (props.formSubmitted ? 'not-allowed' : null)};
  border: ${(props) => (props.formSubmitted ? 'none' : null)};
  transition: all 0.3s ease;

  @media (max-width: 720px) {
    cursor: default;
    position: ${(props) => (props.showPopup ? 'fixed' : 'static')};
    bottom: 0;
    margin: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    z-index: 999;
  }

  .disable {
    background: #d9d9d9;
    cursor: not-allowed;
  }
`;

export const UrlFindContainer = styled.div`
  padding: 40px 50px 10px;
`;

export const FetchUrlBox = styled.div`
  display: flex;
  width: 50%;
  margin-top: 13px;
  column-gap: 26px;
`;

export const ExampleSpan = styled.span`
  font-size: 12px;
`;
